import type { FC } from "react";
import React from "react";

import { Loader, type LoaderProps } from "../../../../Loader";

import type { PickOfUnion } from "../../../../../types/react";
import type { ILoader } from "../../../../Loader/types";

export const BUTTON_LOADER_TEST_ID = "button-loader-test-id";

type ButtonLoaderProps = PickOfUnion<
    LoaderProps,
    "label" | "view" | "customColorsStyles"
> &
    Pick<ILoader, "size">;

export const ButtonLoader: FC<ButtonLoaderProps> = (props): JSX.Element => {
    return <Loader {...props} data-tsid={BUTTON_LOADER_TEST_ID} />;
};

ButtonLoader.displayName = "Button.Loader";

export default ButtonLoader;
